import React from 'react';
import { FormSection } from 'redux-form';
import styled from 'styled-components';

import { Checkbox } from 'components/Shared/Forms';
import { SETTINGS_INPUTS } from 'theme';

const StyledFormSection = styled(FormSection)`
    margin: -${SETTINGS_INPUTS.PADDING.Y} -${SETTINGS_INPUTS.PADDING.X};
    padding-left: ${SETTINGS_INPUTS.PADDING.X};
    padding-right: ${SETTINGS_INPUTS.PADDING.X};
`;

const BehaviorSection = () => {
    return (
        <StyledFormSection name="behavior">
            <Checkbox name="panning" label="Panning" />
            <Checkbox name="keyboardShortcuts" label="Keyboard shortcuts" />
            <Checkbox name="doubleClickToZoom" label="Double click to zoom" />
            <Checkbox name="scrollToZoom" label="Scroll to zoom" />
            <Checkbox name="clickableIcons" label="Clickable points of interest" />
        </StyledFormSection>
    );
};

export default BehaviorSection;
